import { useState } from 'react'
import { Button } from '@components/primitives/Button.js'
import { Modal } from '@components/primitives/Modal.js'

type Props = {
  open: boolean
  nome: string
  onConfirm: () => Promise<void>
  onClose: () => void
}

export function ConfirmDeleteCotacaoModal({ open, nome, onConfirm, onClose }: Props) {
  const [step, setStep] = useState(1)
  const [busy, setBusy] = useState(false)

  const handle = async () => {
    if (step === 1) {
      setStep(2)
      return
    }
    setBusy(true)
    await onConfirm()
    setBusy(false)
    setStep(1)
  }

  const close = () => {
    setStep(1)
    onClose()
  }

  return (
    <Modal
      open={open}
      title='Excluir cotação'
      size='sm'
      onClose={close}
      actions={
        <div className='cf3-modal-actions'>
          <Button variant='ghost' onClick={close} disabled={busy}>
            Cancelar
          </Button>
          <Button variant='danger' onClick={handle} loading={busy}>
            {step === 1 ? 'Excluir' : 'Confirmar exclusão'}
          </Button>
        </div>
      }
    >
      <p className='cf3-confirm-msg'>
        {step === 1 ? (
          <>
            Excluir a cotação de <strong>{nome}</strong>?
          </>
        ) : (
          <>
            Esta ação não pode ser desfeita. Confirma a exclusão de <strong>{nome}</strong>?
          </>
        )}
      </p>
    </Modal>
  )
}
